.fp-chat-page--members
  .fp-chat-page--members--interlocutors
    InterlocutorsListVue(:interlocutors-messages='interlocutorsMessages')
  .fp-chat-page--members--list
    .fp-responsive-grid.-cols4.-cols3-up-lg.-cols2-up-md.-s-sm
      .fp-responsive-grid--column(v-for='(member, index) in membersList' :key='index')
        MemberCardVue(:member='member' :data-test='`member-${index}`')
